<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="fa fa-money"></i>&nbsp;Remessas de Pagamentos
            </div>
            <b-card-body>
                <form @submit.prevent="validate">
                    <div class="form-row justify-content-start">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Status</label>
                                <select :class="{'custom-select': true}" v-model="moneyOutGroupStatus">
                                <option
                                    v-for="(s, index) in moneyOutGroupStatusList"
                                    :key="index"
                                    :value="s.id"
                                >{{s.name}}</option>
                                </select>
                            </div>
                        </div>                
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Início</label>
                                <datepicker
                                    :language="languages.ptBR"
                                    :bootstrapStyling="true"
                                    placeholder="Início"
                                    :calendar-button="true"
                                    calendar-button-icon="fa fa-calendar"
                                    v-model="startDate"
                                ></datepicker>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Término</label>
                                <datepicker
                                    :language="languages.ptBR"
                                    :bootstrapStyling="true"
                                    placeholder="Termino"
                                    :calendar-button="true"
                                    calendar-button-icon="fa fa-calendar"
                                    v-model="endDate"
                                ></datepicker>
                            </div>
                        </div>
                    </div>
                    <input type="submit" class="btn btn-primary" value="Buscar" />
                </form>
            </b-card-body>
        </b-card>
        <b-card>
            <c-table @onPageIndexChanged="onPageIndexChanged" :table-data="result" :actionUri="actionUri" :loading="loading" :fields="fields" striped></c-table>
        </b-card>
    </div>
</template>
<script>
import cTable from "../../../components/base/Table.vue";
import domainService from "../../../services/MoneyFlow/moneyOutGroupService";
import listPage from "../../../mixins/listPage";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { getDateMonthsBefore } from "../../../shared/utils";
export default {
    components: {
        cTable,
        Datepicker    
    },
    mixins: [listPage],
    data() {
        return {
            languages: lang,
            startDate: getDateMonthsBefore(new Date(), 1),
            endDate: new Date(),
            moneyOutGroupStatus: '',
            actionUri: 'partners/paymentgroups',
            fields: [
                {key: 'controlNumber', label: 'Cod. controle', sortable: false},
                {key: 'name', label: 'Nome', sortable: false},
                {key: 'bankCode', label: 'Banco', sortable: false},
                {key: 'amount', label: 'Valor', sortable: false},
                {key: 'status', label: 'Status', sortable: false},
                {key: 'createdAt', label: 'Data Criação', sortable: false},
                {key: 'actions', label: ''}
            ],
            moneyOutGroupStatusList: [
                { id: '', name: 'Todos' },
                { id: 'CREATED', name: 'Criado' },
                { id: 'PROCESSING', name: 'Processando' },
                { id: 'DONE', name: 'Finalizado' }
            ]
        }
    },
    methods: {
        validate() {
            this.fetchData(1);
        },
        fetchData(page) {
            const self = this
            self.showLoading()
            domainService.findAll({ startDate: this.startDate, endDate: this.endDate,  status: this.moneyOutGroupStatus}, page).then((response) =>{
                self.$data.result = response.status == 204 ? self.getEmptyResult() : response.data
                self.hideLoading()
            }, () =>{
                self.hideLoading()
            }   )
        }
    }
}
</script>